import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const HeroChemical = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box marginBottom={2}>
      <Container
        sx={{
          backgroundImage:
            themeMode === 'dark'
              ? 'url(/images/logos/logo_white.PNG)'
              : 'url(/images/logos/logo_tnonetwork_black.png)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          height: '16vh',
        }}
      />

      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        variant="overline"
        color="textSecondary"
        align="center"
        display="block"
        gutterBottom
      >
        Distribuidora · Propuesta comercial
      </Typography>

      <Box
        component={Typography}
        fontWeight={700}
        variant="h3"
        gutterBottom
        align="center"
        color={theme.palette.primary.main}
        sx={{ px: 1 }}
      >
        Chemical x TNO Network
      </Box>

      <Typography
        variant="h6"
        component="p"
        color="textSecondary"
        align="center"
        sx={{ fontStyle: 'italic', mb: 2 }}
      >
        Emprende con brillo: tu negocio de limpieza 2.0
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Box
          component="img"
          src="/images/chemical.jpeg"
          alt="Chemical"
          sx={{
            width: '100%',
            maxWidth: 200,
            maxHeight: 140,
            objectFit: 'contain',
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </Box>

      <Box
        sx={{
          maxWidth: 720,
          mx: 'auto',
          py: 2,
          px: 2,
          borderRadius: 2,
          bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
        }}
      >
        <Typography variant="body1" color="textSecondary" align="center" paragraph sx={{ mb: 2 }}>
          En el sector limpieza, la clave es separar el <strong>aspiracional de negocio</strong> (Chemical, distribución
          y red) del <strong>rendimiento del producto</strong> (marca de consumo). Chemical se presenta con el enfoque{' '}
          <strong>Soluciones que brillan</strong>: usar <strong>TNO Network</strong> para generar confianza, leads
          calificados y ventas directas —no solo avisos, sino un imán de emprendedores.
        </Typography>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ mb: 0 }}>
          Esta propuesta no vende jabón: vende <strong>libertad financiera</strong>. El objetivo es reclutar nuevos
          emprendedores y distribuidores con contenido útil, autoridad y prueba social en vivo.
        </Typography>
      </Box>
    </Box>
  );
};

HeroChemical.propTypes = {
  themeMode: PropTypes.string,
};

export default HeroChemical;
